// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"9d033dfe","710":"0da1b304","983":"4ef7f7bc"}[chunkId] + ".chunk.js";
};